import React from 'react'
import intl from 'react-intl-universal'

export const SelectedItemCtx = React.createContext()

export const getSearchUrl = (text) => {
  const value = text.split('---')
  switch (value[0]) {
    case 'admission/school':
      return `/directory/${value[1]}`
    case 'province':
      return `/directory?location=${value[1]}`
    case 'city':
      return `/directory?city=${value[1]}`
    case 'career/profession':
      return `/careers/${value[1]}`
    case 'career/field':
      return `/careers?filter=${value[1]}`
    case 'admission/study_field_campus':
      return `/directory?study_field=${value[1]}`
    case 'campus/scholarship':
      return `/scholarships/${value[1]}`
    case 'campus/assessment':
      return `/tests/${value[1]}`
    default:
      return `/majors/${value[1]}`
  }
}

export const getIconCategory = (category) => {
  switch (category) {
    case 'admission/school':
      return ({
        icon: 'school',
        title: intl.get('autocomplete.kind.admission/school'),
      })
    case 'admission/study_field':
      return ({
        icon: 'course',
        title: intl.get('autocomplete.kind.admission/study_field'),
      })
    case 'city':
      return ({
        icon: 'city',
        title: intl.get('autocomplete.kind.city'),
      })
    case 'province':
      return ({
        icon: 'province',
        title: intl.get('autocomplete.kind.province'),
      })
    case 'career/profession':
      return ({
        icon: 'campus-business',
        title: intl.get('autocomplete.kind.career/profession'),
      })
    case 'career/field':
      return ({
        icon: 'campus-business',
        title: intl.get('autocomplete.kind.career/field'),
      })
    case 'campus/scholarship':
      return ({
        icon: 'scholarship',
        title: intl.get('autocomplete.kind.campus/scholarship'),
      })
    case 'campus/assessment':
      return ({
        icon: 'aptitude',
        title: intl.get('autocomplete.kind.campus/assessment'),
      })
    default:
      return ({
        icon: 'school',
        title: 'Kampus Rekomendasi',
      })
  }
}
